import Vue from 'vue';
import fundebug from 'fundebug-javascript';
import dev from '../services/dev';

fundebug.apikey =
  'b224217e15db6f15396164c8877fb58e39c92e0255ce91956d07acdb0c56a084';

fundebug.metaData = {
  project: 'pdv-h5',
};

fundebug.filters = [
  {
    res: {
      status: /^401$/,
    },
  },
  {
    res: {
      status: /^0$/,
    },
  },
  {
    res: {
      status: /^403$/,
    },
  },
  {
    res: {
      status: /^404$/,
    },
  },
  {
    message: /WeixinJSBridge|WebViewJavascriptBridge/,
  },
  {
    message: /Script error/,
  },
  {
    message:
      /SyntaxError|ResizeObserver|UC|(PerformanceObserverInit)|(changeNetWork)|(__WX_AWM_MC__)/,
  },
  {
    type: /^unhandledrejection$/,
  },
  {
    target: {
      tagName: /^IMG$/,
    },
  },
  {
    req: {
      url: /qq\.com/,
    },
  },
];

function formatComponentName(vm) {
  if (vm.$root === vm) return 'root';

  const name = vm._isVue
    ? (vm.$options && vm.$options.name) ||
      (vm.$options && vm.$options._componentTag)
    : vm.name;
  return (
    (name ? `component <${name}>` : 'anonymous component') +
    (vm._isVue && vm.$options && vm.$options.__file
      ? ` at ${vm.$options && vm.$options.__file}`
      : '')
  );
}

// dev 大于0代表开发或者测试环境，这些环境都不需要监控
(() => {
  if (!dev) {
    Vue.config.errorHandler = (err, vm, info) => {
      const componentName = formatComponentName(vm);
      const propsData = vm.$options && vm.$options.propsData;
      fundebug.notifyError(err, {
        metaData: {
          componentName,
          propsData,
          info,
        },
      });
    };
  } else {
    fundebug.silent = true;
  }
})();
